
sap["ls"]["preload"]["UCF_FeatureFlagsRenderer"] = function() {function UCF_FeatureFlagsRenderer () {if (__UCF_COVERAGE__) { UCF_FeatureFlagsRenderer["_"]["UCF_FeatureFlagsRenderer"]++; }; };window["UCF_FeatureFlagsRenderer"] = UCF_FeatureFlagsRenderer; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_FeatureFlagsRenderer"); UCF_FeatureFlagsRenderer["_"] = {UCF_FeatureFlagsRenderer: 0}; }; ;
									UCF_FeatureFlagsRenderer["render"] = function(oRenderInfo, oRenderManager) {;if (__UCF_COVERAGE__) { UCF_FeatureFlagsRenderer["_"]["render"]++; }; 
									var oControl = oRenderInfo["_oControl"];
									if (oControl) {
										oRenderManager["addRenderedControl"](oControl);
										oControl["onBeforeRendering"]();
									}
									this["renderFeatureFlagsFragment"](oRenderInfo, oRenderManager);
								};;if (__UCF_COVERAGE__) { UCF_FeatureFlagsRenderer["_"]["render"] = 0; };


UCF_FeatureFlagsRenderer["renderFeatureFlagsFragment"] = function(oRenderInfo, oRenderManager) {;if (__UCF_COVERAGE__) { UCF_FeatureFlagsRenderer["_"]["renderFeatureFlagsFragment"]++; }; 
			



};;if (__UCF_COVERAGE__) { UCF_FeatureFlagsRenderer["_"]["renderFeatureFlagsFragment"] = 0; };

UCF_FeatureFlagsRenderer["renderIsEnabled"] = function(oRenderInfo, oRenderManager) {;if (__UCF_COVERAGE__) { UCF_FeatureFlagsRenderer["_"]["renderIsEnabled"]++; }; 
			var p = oRenderInfo; 
			var r = oRenderManager; 
			p["Enabled"] = false;
			
	p["FeatureFlags"] = "";

	p["FeatureFlags"] = this["renderGetFeatureFlags"]({
		"Events":{}},r);

	p["Enabled"] = window["UCF_System"]["sFeatureChannel"] === "NIGHTLY" || (typeof(p["FeatureFlags"]) === "string" && p["FeatureFlags"]["indexOf"](p["Feature"])>-1);

return p["Enabled"]
};;if (__UCF_COVERAGE__) { UCF_FeatureFlagsRenderer["_"]["renderIsEnabled"] = 0; };

UCF_FeatureFlagsRenderer["renderGetFeatureFlags"] = function(oRenderInfo, oRenderManager) {;if (__UCF_COVERAGE__) { UCF_FeatureFlagsRenderer["_"]["renderGetFeatureFlags"]++; }; 
			var p = oRenderInfo; 
			p["FeatureFlags"] = "";
			
	p["BetaFeatureFlags"] = "";

	p["BetaFeatureFlags"] = "FeatureFlags,Fields.Overlay,SelectionCell.Standards,Splitter.Standards,Control.AllowTextSelection";

	p["FeatureFlags"] = window["UCF_System"]["sFeatureFlags"];

	if (window["UCF_System"]["sFeatureChannel"] === "BETA" && p["BetaFeatureFlags"] !== "")
	{
			if (p["FeatureFlags"] !== "")
		{
					p["FeatureFlags"] = p["FeatureFlags"] + ",";

		}
		p["FeatureFlags"] = p["FeatureFlags"] + p["BetaFeatureFlags"];

	}
return p["FeatureFlags"]
};;if (__UCF_COVERAGE__) { UCF_FeatureFlagsRenderer["_"]["renderGetFeatureFlags"] = 0; };


};